<template>
    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button v-if="showSidebar" class="layout-menu-button layout-topbar-action" @click="toggleMenu">
                <i class="pi pi-bars"></i>
            </button>
            <router-link to="/" class="layout-topbar-logo">
                <img src="/logo.svg" alt="sakai" />
                <span>Portal</span>
            </router-link>
        </div>
        <Menubar :model="items" class="layout-topbar-menubar"> 
            <template #item="{ item, props, hasSubmenu }">
                 <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                    <a v-ripple :href="href" v-bind="props.action" @click="navigate">
                        <span :class="item.icon" />
                        <span>{{ item.label }}</span>
                    </a>
                </router-link>
                  <a v-else-if="item.flagicon" v-bind="props.action" class="topbar-item flex items-center gap-1 font-medium cursor-pointer">
                    <img :src="item.flagicon" class="w-5 h-4" />
                     <span :class="{ 'font-semibold text-[var(--ghm-primary)]': locale === item.localeId }">{{ item.label }}</span>
                  </a>
                <a v-else v-ripple :href="item.url" :target="item.target" v-bind="props.action">
                    <span :class="item.icon" />
                    <span>{{ item.label }}</span>
                    <span v-if="hasSubmenu" class="pi pi-fw pi-angle-down" />
                </a>
                <LogoutButton variant="menu" v-if="item.isLogoutComponent" class="w-full" />
            </template>
           <template #end>
                <div class="hidden lg:flex items-center gap-4"> 
                    <div class="topbar-item">
                        <span class="font-medium cursor-pointer flex items-center"  @mouseenter="op.toggle($event)" @mouseleave="op.hide()">
                            <i class="pi pi-user pr-1"></i>
                            <span class="pl-1">{{ authStore.user.preferred_username }}</span>
                        </span>
                        <Popover ref="op">
                            <div class="p-2">
                                <div><b>Name:</b> {{ authStore.user.preferred_username }}</div>
                            </div>
                        </Popover>
                    </div>
                    <div class="relative group">
                        <LogoutButton></LogoutButton>
                    </div>
                </div>
            </template>
        </Menubar>
    </div>
</template>

<script setup>
import Menubar from 'primevue/menubar';
import Popover from 'primevue/popover';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import LogoutButton from '@/components/mics/LogoutButton.vue';
import { useLayout } from '@/layout/composables/layout';
import { useAuthStore } from "@/stores/auth.store";
import { setLocale } from './../i18n.js'
import flagDe from '@/assets/flags/de.svg'; 
import flagEn from '@/assets/flags/en.svg'; 


const op = ref();
const { toggleMenu } = useLayout();
const authStore = useAuthStore();
const { t, locale } = useI18n();
const router = useRouter(); 

const props = defineProps({
    showSidebar: {
        type: Boolean,
        required: true
    }
});

const items = computed(() => {
    const menuItems = [
        {
            label: t('topBar.company'),
            items: [
                {
                    label: t('topBar.aboutus'),
                    url: 'https://www.ghm.de/de/unternehmen/ueber-uns/',
                    target: '_blank'
                },
                {
                    label: t('topBar.imprint'),
                    url: 'https://www.ghm.de/de/impressum/',
                    target: '_blank'
                },
                {
                    label: t('topBar.privacy'), 
                    url: 'https://www.ghm.de/de/datenschutz/',
                    target: '_blank'
                }
            ]
        },
        {
            label: t('global.language'),
            items: [
                {
                    label: t('languages.german'),
                    flagicon: flagDe,
                    localeId: 'de', 
                    command: () => setLocale('de')
                },
                {
                    label: t('languages.english'),
                    flagicon: flagEn,
                    localeId: 'en',
                    command: () => setLocale('en')
                }
            ]
        },
    ];

    if (authStore.isAdmin() || authStore.isEmployee()) {
        const adminLanding = authStore.isAdmin() ? '/admin/events' : '/admin/users';
        menuItems.push({
            label: 'Admin Area',
            icon: 'pi pi-lock',
            command: () => {
                router.push(adminLanding);
            },
        });
    }

    menuItems.push({
        label: authStore.user.preferred_username,
        icon: 'pi pi-user', 
        class: 'lg:hidden', 
        items: [
            {
                isLogoutComponent: true
            }
        ]
    });

    return menuItems;
});
</script>

<style scoped>
.layout-topbar {
    border-bottom: 2px solid var(--ghm-primary);
    
}

.layout-topbar .p-menubar {
    margin-left: auto; 
    background: transparent;
    border: none;
    padding: 0;
}

</style>

<style>
@media screen and (max-width: 991px) {
   .layout-topbar .layout-topbar-menubar .p-menubar-root-list {
        top: 3.5rem ; 
        right: 0.5rem; 
        left: auto ; 
        min-width: 300px;
       
    }

    .admin-layout .layout-topbar-menubar {
        display: none !important;
    }
}
</style>
